import SearchScan from './SearchScan';
import { ActionIcon, Box, Container, Group, Image } from '@mantine/core';
import { NavLink, useNavigate } from 'react-router-dom';
import NavMenu from './NavMenu';
import { ROUTES } from '../config/RoutesName';
import { useDispatch } from 'react-redux';
import { phoneFocus } from '../redux/slices/inputFocusSlice';
import { backArrow, cart, logoText, logoicon } from '../assets';

interface GlobalProps {
  close: (arg: any) => void;
}

const GlobalSearch = ({ close }: GlobalProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const searchInput = async (value: any) => {
    navigate(ROUTES.DETAILS + '/' + `${value.restaurant_id}`, {
      state: {
        restaurantInfo: {
          restaurantName: value.name,
          rating: Number(value.rating.average_rating),
          ratingCount: value.rating.count,
          openingHours: `${value.business_hour.opening_time} - ${value.business_hour.closing_time}`,
          fullAddress: value.full_address,
        },
      },
    });
  };

  return (
    <>
      <Container p='20px 10px'>
        <Group position='apart'>
          {/* <ActionIcon>
            <Image width='auto' height='auto' src={backArrow} onClick={close} />
          </ActionIcon> */}
          <NavLink to={`${ROUTES.HOME}`}>
            <Group position='center' spacing='2px' pl={25}>
              <Image width='auto' height='auto' src={logoicon} />
              <Image width='auto' height='auto' src={logoText} />
            </Group>
          </NavLink>

          <Group spacing={30}>
            <NavLink
              to={`${ROUTES.CART}`}
              onClick={() => dispatch(phoneFocus(false))}
              style={{ textDecoration: 'none', color: 'black' }}>
              <ActionIcon>
                <Image width='auto' height='auto' src={cart} />
              </ActionIcon>
            </NavLink>
            <NavMenu />
          </Group>
        </Group>
        <Box pt={'35px'}>
          <SearchScan searchInput={searchInput} searchComponent={true} />
        </Box>
      </Container>
    </>
  );
};

export default GlobalSearch;
